const NewsletterContentButton = ({text, url, color, textStyles={}, backgroundColor = "transparent"}) => (
    <td className="buttonContent" align="center" valign="middle" style={{padding: "5px 10px", textAlign: "center", color: color}}>
        <a href={url} target="_blank" style={{...{display: "block", color: color, backgroundColor: backgroundColor, textDecoration: "none"}, ...textStyles}}>{text}</a>
    </td>
)

export default NewsletterContentButton